<template>
  <div>
    <div class="px-5">
      <div class="text-h4 font-weight-black">Contact Us</div>
    </div>
    <div class="wrap-contact px-5 my-5">
      <div>
        <v-img
          class="logo"
          lazy-src="../../assets/img/logo-teman-bakat.png"
          max-height="400"
          max-width="400"
          src="../../assets/img/logo-teman-bakat.png"
        ></v-img>
      </div>
      <div class="mt-5">
        <div class="text-h5 font-weight-black">Teman Bakat</div>
        <div class="text font-weight-medium">PT Hara Anargya Indonesia</div>
        <div class="text">Graha Mulia Sejahtera JL.Terusan</div>
        <div class="text">Jakarta No. 175A Kel.Antapani</div>
        <div class="text">Kulon, Kota Bandung</div>
        <div class="text">+62877 1449 1482</div>
        <div class="text">temanbakat@gmail.com</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ContactUs",
};
</script>
<style scoped>
@media only screen and (min-width: 992px) {
  .wrap-contact {
    display: flex;
  }
  .logo {
    width: 250px;
    height: 250px;
  }
}
</style>
